import { Route } from '@angular/router';

export const companyRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./company-list/company-list.component').then((c) => c.CompanyListComponent),
  },
];
